module.exports = __webpack_public_path__ + "img/woman-qrcode.06b7f611.png";